import { Dialog, DialogProps } from "../core/components/dialog";
import { Config } from "../core/config/config";
import { FieldInstance } from "../core/components/field";
import { TextBox } from "../core/components/textBox";
import { ComponentHelper } from "../core/util/componentHelper";
import { Helper } from "../core/util/helper";
import { AppHelper } from "../appHelper"
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { MultiSelect, MultiSelectProps } from "../core/components/multiSelect";
import { CRTranslation } from "./crQuestion"
import React from "react"
export class CRTranslationsDialog extends React.Component<CRTranslationsDialogProps, CRTranslationsDialogState> {
    common = new AppHelper();
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: "Translations",
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this._onOk();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.closeDialog();
        },
        width: 500
    };

    constructor(props: CRTranslationsDialogProps) {
        super(props);
        let translations = props.data;
        if (!Helper.hasValue(translations))
            translations = [];
        this.state = { dialogOpen: false, currentLanguageSelection: [], translations: translations };
    }

    private _onOk = () => {
        let selected = this.state.currentLanguageSelection;
        let values: CRTranslation[] = [];
        for (let i = 0; i < selected.length; i++) {
            let text = "";
            let item = this.state.translations.find(f => f.Key.Id === selected[i].Language);
            if (Helper.hasValue(item))
                text = item.Value;
            values.push({
                Key: {
                    Id: selected[i].Language,
                    Name: selected[i].Sprache
                },
                Value: text
            });
        }
        this.props.onOkClick(values);
    }

    private _createLink = () => {
        const labelStyle: React.CSSProperties = {
            cursor: "pointer",
            textDecoration: "Underline"
        }
        const divStyle: React.CSSProperties = {
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "10px",
            marginTop: "2px"

        }
        return (
            <>
                <div style={divStyle}>
                    <label style={labelStyle} onClick={this.openDialog}>{Helper.getTranslation("WebSMS.Report.Question.EditTranslations")}</label>
                </div>

            </>
        );
    }

    private _createDialog = () => {
        if (this.state.dialogOpen) {
            return (
                <div>
                    <Dialog {...this._dialogProps} open={this.state.dialogOpen}>
                        <FullHeightContainer>
                            {this._createMultiSelect()}
                            {this._createTextBoxes()}
                        </FullHeightContainer>
                    </Dialog>
                </div>
            );
        } else {
            return (<></>);
        }
    }

    private _createMultiSelect = () => {
        let props: MultiSelectProps = this._factory.getDefaultMultiSelectProps();
        props.value = this.state.currentLanguageSelection;
        props.field.dataSourceUrl = "TranslationsView/GetLanguages";
        props.field.dataValueField = "Language";
        props.field.dataTextField = "Sprache";
        props.onChange = this._handleMultiSelect;

        return (
            <FieldInstance label={Helper.getTranslation("Sprachen.Sprachen")} noHover={true} >
                <MultiSelect {...props} />
            </FieldInstance>
        );
    }

    private _handleMultiSelect = (field: { model: string }, value: Array<{ Language: number, Sprache: string }>) => {
        this.setState({ currentLanguageSelection: value });
    }

    private _createTextBoxes = () => {
        let elemets = [];
        for (let i = 0; i < this.state.currentLanguageSelection.length; i++) {
            const t = this.state.currentLanguageSelection[i];
            elemets.push(
                <div key={kendo.guid()} style={{ flexShrink: 0 }}>
                    <FieldInstance label={t.Sprache} noHover={true} >
                        <TextBox {...this._createTextBoxProps(t)} />
                    </FieldInstance>
                </div>
            );
        }
        return elemets;
    }

    private _createTextBoxProps = (t: { Language: number, Sprache: string }) => {
        let props = this._factory.getDefaultTextBoxProps();
        props.field.name = t.Sprache + "|" + t.Language;
        props.onChange = this.handleTextBoxesChances;
        let value = "";
        let translation = this.state.translations.find(f => f.Key.Id === t.Language);
        if (Helper.hasValue(translation)) {
            value = Helper.getValueOrDefault(translation.Value, "");
        }
        props.value = value;
        return (props);
    }

    handleTextBoxesChances = (field: { model: string, name: string }, value: any) => {
        let id = parseInt(field.name.split("|")[1]);
        let translation = this.state.translations.find(f => f.Key.Id === id);
        if (!Helper.hasValue(translation)) {
            translation = {
                Key: {
                    Id: id,
                    Name: field.name.split("|")[0]
                },
                Value: value
            };
        } else {
            translation.Value = value;
        }
        let pos = this.state.translations.indexOf(translation);
        let translations = this.state.translations.slice(0);
        if (pos < 0) {
            translations.push(translation);
        } else {
            translations[pos] = translation;
        }
        this.setState({ translations: translations });
    }

    openDialog = () => {
        this.setState({ dialogOpen: true });
    }

    closeDialog = () => {
        this.setState({ dialogOpen: false });
    }

    render() {
        let link = this._createLink();
        let dialog = this.state.dialogOpen ? this._createDialog() : null;
        return (
            <>
                {link}
                {dialog}
            </>
        );

    }
}

interface CRTranslationsDialogState {
    dialogOpen: boolean;
    translations: CRTranslation[];
    currentLanguageSelection: Array<{ Language: number, Sprache: string }>;
}

interface CRTranslationsDialogProps {
    data: CRTranslation[];
    onOkClick: (values: CRTranslation[]) => void;
}